import { actionsTypes as types } from "../actions/devicesActions";
import { toast } from "react-toastify";
import { unescapeHTML } from "../helpers/unescapeHTML";
const INITIAL_STATE = [];

const INITIAL_SENSORCONFIG = {
  name: {
    value: "",
    method: undefined
  },
  value: {
    value: "",
    method: undefined
  },
  value_factor: {
    value: 1,
    method: "manual"
  },
  value_offset: {
    value: 0,
    method: "manual"
  },
  unit: {
    value: "",
    method: undefined
  },
  time: {
    value: "",
    method: undefined
  },
  color: {
    value: "",
    method: undefined
  },
  geo: {
    value: "",
    method: undefined
  }
};

const INITAL_DATACONFIG = {
  name: {
    value: "",
    method: undefined
  },
  color: {
    value: "",
    method: undefined
  },
  geo: {
    value: "",
    method: undefined
  }
};

const devicesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ADD_DEVICE:
      toast.success("Device Added");
      return [
        {
          uid: action.uid,
          comConfig: {
            apiKey: action.apikey
          },
          dataConfig: INITAL_DATACONFIG,
          sensorConfig: {},
          rawJSONS: [],
          lastContact: 0,
          template_id: false
        },
        ...state
      ];

    // This action is also hijacked by widgetConfigReducer!
    case types.DELETE_DEVICE:
      toast.warn("Device Deleted");
      return state.filter(device => {
        return device.uid !== action.uid;
      });

    case types.RECEIVE_DEVICES:
      let { devices } = action;
      devices.sort((a, b) => {
        return b.id - a.id;
      });

      // TEMP: Convert sensors array do object
      function sensorConfObj(sensorArr) {
        let obj = {};
        sensorArr.forEach(sensor => {
          obj[sensor.id] = {
            ...INITIAL_SENSORCONFIG,
            ...sensor.config
            //            resolvedConfig: sensor.json_properties
          };
        });

        return obj;
      }

      // Initial Live values from action
      function initialLiveValues(sensorArr) {
        let obj = {};
        sensorArr.forEach(sensor => {
          if (sensor.last_value && sensor.last_value_time) {
            obj[sensor.id] = {
              value: sensor.last_value,
              date: sensor.last_value_time
            };
          }
        });

        return obj;
      }

      return devices.map(device => {
        return {
          uid: device.id,
          comConfig: {
            apiKey: device.apikey
          },
          dataConfig: { ...INITAL_DATACONFIG, ...device.config },
          resolvedDataConfig: { ...device.result_properties },
          sensorConfig: { ...sensorConfObj(device.sensors) },
          resolvedSensorConfig: { ...sensorResolvedConfObj(device.sensors) },
          rawJSON: device.combined_json || {},
          lastContact: device.last_seen || 0,
          liveSensorValues: initialLiveValues(device.sensors),
          template_id: device.applied_template_name,
          histoSensorValues: {} //(cached live values, not to be confused with sensorHisto which has own reducer)
        };
      });

    case types.ADD_SENSOR:
      toast.success("Sensor Added");
      return state.map(device => {
        return device.uid === action.device_uid
          ? {
              ...device,
              sensorConfig: {
                ...device.sensorConfig,
                [action.sensor_uid]: INITIAL_SENSORCONFIG
              }
            }
          : device;
      });

    // This action is also hijacked by widgetConfigReducer!
    case types.DELETE_SENSOR:
      toast.warn("Sensor Deleted");
      return state.map(device => {
        if (device.uid === action.device_uid) {
          // Using es6 destructuring with rest to immutably delete one sensor.
          const {
            [action.sensor_uid]: undefined,
            ...without
          } = device.sensorConfig;
          return {
            ...device,
            sensorConfig: without
          };
        } else {
          return device;
        }
      });

    case types.RECEIVE_RAW_JSON:
      let newRawJSON = action.JSONString;
      return state.map(device => {
        return device.uid === action.uid
          ? {
              ...device,
              rawJSON: newRawJSON,
              lastContact: Date.now()
            }
          : device;
      });

    case types.RESET_RAW_JSON:
      console.log("Reducer: RESET RAW JSON");
      return state.map(device => {
        return device.uid === action.uid
          ? {
              ...device,
              rawJSON: undefined
            }
          : device;
      });

    case types.RECEIVE_SENSOR_VALS:
      // This reducer methods has 2 tasks:
      // 1. Save the live sensor values per sensor (liveSensorValues)
      // 2. Augment the histo sensor values per sensor (histoSensorValues)

      let _sensorObj = sensorObj(action.sensor_values);
      //console.log("device ", _sensorObj);

      return state.map(device => {
        let rv;
        if (device.uid === action.uid) {
          // Augment  histoSensorValues array (cached live values, not to be confused with sensorHisto which has own reducer) per sensor with new live datum
          let augmentedHistoSensorValues = {...device.histoSensorValues} || {};
          Object.keys(_sensorObj).forEach(sensorid => {
            if (
              augmentedHistoSensorValues 
            ) {
              if (!augmentedHistoSensorValues[sensorid]) {
                augmentedHistoSensorValues[sensorid] = {}
              }
              // The slice call behaves like pop, but without mutation
              // TODO: Because of the potential unconsistent time between steps, just popping the old value might
              // not be optimal. Maybe write some code here, to delete as many of the oldest values here, to
              // compensate for the time step of the newest value...
              let currentHistoValuesForSensor = device.histoSensorValues[sensorid] || []
              if (currentHistoValuesForSensor.length < 100) {
                augmentedHistoSensorValues[sensorid] = [
                  ...currentHistoValuesForSensor,
                  _sensorObj[sensorid]
                ];
              } else {
                augmentedHistoSensorValues[sensorid] = [
                  ...device.histoSensorValues[sensorid].slice(1),
                  _sensorObj[sensorid]
                ];
              }
            }
          });
          //
          rv = {
            ...device,
            liveSensorValues: {
              ...device.liveSensorValues,
              ..._sensorObj
            },
            histoSensorValues: augmentedHistoSensorValues
          };
        } else {
          rv = device;
        }
        return rv;
      });

    case types.RECEIVE_DEVICE_RESULT_PROPS: {
      console.log("RECEIVE_DEVICE_RESULT_PROPS reducer called!", action);
      let { deviceid, result_properties = {} } = action;
      //resolvedDataConfig: { ...device.result_properties },
      return state.map(device => {
        return device.uid === deviceid
          ? {
              ...device,
              resolvedDataConfig: {
                ...device.resolvedDataConfig,
                ...result_properties
              }
            }
          : device;
      });
    }

    case types.RECEIVE_SENSOR_RESULT_PROPS: {
      console.log("RECEIVE_SENSOR_RESULT_PROPS reducer called!");
      let { deviceid, sensors = [] } = action;

      let _resolvedSensorConfig = {};
      try {
        _resolvedSensorConfig = sensorResolvedConfObj(sensors);
      } catch (error) {
        console.error("Error while processing resolved sensor config");
      }
      return state.map(device => {
        return device.uid === deviceid
          ? {
              ...device,
              resolvedSensorConfig: {
                ...device.resolvedSensorConfig,
                ..._resolvedSensorConfig
              }
            }
          : device;
      });
    }

    // case types.RECEIVE_SENSOR_HISTO_DATA:
    //   //console.log("REDUCER RECEIVE_DEVICE_HISTO_DATA:", action.data);

    //   return state.map(device => {
    //     return device.uid === action.deviceid
    //       ? {
    //           ...device,
    //           histoSensorValues: {
    //             ...device.histoSensorValues,
    //             [action.sensorid]: action.data
    //           }
    //         }
    //       : device;
    //   });

    case types.SET_DEVICE_DATA_VAL:
      let { key, value, method } = action;

      return state.map(device => {
        return device.uid === action.uid
          ? {
              ...device,
              dataConfig: {
                ...device.dataConfig,
                [key]: {
                  value,
                  method
                }
              }
            }
          : device;
      });

    case types.SET_DEVICE_SENSOR_DATA_VAL: {
      let { uid, sensorUid, key, value, method } = action;
      console.log("here", action);
      return state.map(device => {
        return device.uid === uid
          ? {
              ...device,
              sensorConfig: {
                ...device.sensorConfig,
                [sensorUid]: {
                  ...device.sensorConfig[sensorUid],
                  [key]: {
                    value,
                    method
                  }
                }
              }
            }
          : device;
      });
    }

    case types.SET_DEVICE_TEMPLATE_ID: {
      console.log("SET_DEVICE_TEMPLATE_ID Reducer called!", action);

      let { uid, template_id } = action;

      return state.map(device => {
        return device.uid === uid
          ? {
              ...device,
              template_id: template_id
            }
          : device;
      });
    }

    default:
      return state;
  }
};

export default devicesReducer;

// fcts

// TEMP: Convert sensors array do object
function sensorResolvedConfObj(sensorArr) {
  let obj = {};
  sensorArr.forEach(sensor => {
    for (const key in sensor.result_properties) {
      if (sensor.result_properties.hasOwnProperty(key)) {
        sensor.result_properties[key] = {
          value: unescapeHTML(sensor.result_properties[key])
        };
      }
    }

    obj[sensor.id || sensor.sensor_config_id] = {
      ...sensor.result_properties
    };
  });
  return obj;
}

// TEMP: Convert sensors array to object
function sensorObj(sensorArr) {
  let obj = {};
  sensorArr.forEach(sensor => {
    obj[sensor.sensor_config_id] = {
      date: sensor.time,
      value: sensor.value
    };
  });
  return obj;
}
